import React from 'react';
import { Badge } from '@components/ui/badge';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger
} from '@components/ui/tooltip';
import { GpxAnalysisAction } from '../../core/api/FitnessActivityClient';

type BadgeVariant = 'destructive' | 'warning' | 'info' | 'success';

const actionVariants: Record<GpxAnalysisAction, BadgeVariant> = {
    [GpxAnalysisAction.VEHICLE]: 'destructive',
    [GpxAnalysisAction.CORRUPT]: 'destructive',
    [GpxAnalysisAction.REVIEW]: 'warning',
    [GpxAnalysisAction.ACCEPT_DIRTY]: 'info',
    [GpxAnalysisAction.ACCEPT]: 'success'
};

const actionLabels: Record<GpxAnalysisAction, string> = {
    [GpxAnalysisAction.VEHICLE]: 'GPX: vehicle',
    [GpxAnalysisAction.CORRUPT]: 'GPX: corrupt',
    [GpxAnalysisAction.REVIEW]: 'GPX: review',
    [GpxAnalysisAction.ACCEPT_DIRTY]: 'GPX: dirty',
    [GpxAnalysisAction.ACCEPT]: 'GPX: clean'
};

interface GpxAnalysisChipProps {
    action?: GpxAnalysisAction;
    reason?: string;
}

export function GpxAnalysisChip({ action, reason }: GpxAnalysisChipProps) {
    if (!action) return null;

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Badge variant={actionVariants[action]}>
                    {actionLabels[action]}
                </Badge>
            </TooltipTrigger>
            <TooltipContent>
                {reason
                    ? `Shadow verdict, no decision taken — ${reason}`
                    : 'Shadow verdict, no decision taken'}
            </TooltipContent>
        </Tooltip>
    );
}
